var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.schoolName)?_c('div',[_vm._v(_vm._s(_vm.displaySchool))]):_vm._e(),(_vm.location)?_c('div',{staticClass:"request-school__location"},[_vm._v(_vm._s(_vm.location))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }